
import React, { useState } from 'react';
import cb from '../Resource/Contact/club-hs-bg.png';
import '../Styles/Contact.css';
import axios from "axios";
import {
  getCampaignId,
  getConversionLabel,
  gtag_report_conversion,
} from './ConversionHandler.js';

export const Contact = () => {
  const campaignId = getCampaignId();

  const [formData, setFormData] = useState({
    fname: '',
    number: '',
    email: '',
    'lead-message': '',
    secret: 'norg2021' // Replace with actual secret
  });

  const getSourceFromURL = () => {
    const params = new URLSearchParams(window.location.search);
    return params.get('s') || '258';
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const label = getConversionLabel('form', campaignId);
    console.log('📨 Form submitted - Conversion Label:', label);

    const payload = {
      name: formData.fname,
      email: formData.email,
      number: formData.number,
      'lead-message': formData['lead-message'],
      source: getSourceFromURL(),
      secret: formData.secret
    };

    try {
      const response = await axios.post('https://krushika.org/crm/endpoint.php', payload);
      console.log('Form submitted successfully', response.data);
    } catch (error) {
      console.error('Error submitting form', error);
    }

    const callback = () => {
      console.log('✅ Conversion recorded. Redirecting or showing message...');
      alert('Thank you! Your message has been sent successfully.');
    };

    if (window.gtag) {
      window.gtag('event', 'conversion', {
        send_to: label,
        event_callback: callback,
      });
    } else {
      console.warn('⚠️ gtag not available. Fallback...');
      callback();
    }
  };

  return (
    <div className='Contac-container'>
      <div className='Contact-container-left'>
        <h1>Contact Us</h1>
        <p>Your comfort, questions, and feedback matter to us.</p>
        <img src={cb} className='contact-img' alt="Contact Illustration" />
      </div>

      <div className='Contact-container-right'>
        <h1>Please fill in the details below</h1>
        <form className='Contact-container-right-form' onSubmit={handleSubmit}>
          <input
            type='text'
            name='fname'
            placeholder='Name'
            className='Contact-container-right-input'
            value={formData.fname}
            onChange={handleChange}
            required
          />
          <input
            type='tel'
            name='number'
            placeholder='Phone Number'
            className='Contact-container-right-input'
            value={formData.number}
            onChange={handleChange}
            required
          />
          <input
            type='email'
            name='email'
            placeholder='Email'
            className='Contact-container-right-input'
            value={formData.email}
            onChange={handleChange}
            required
          />
          <textarea
            name='lead-message'
            placeholder='Your Message'
            className='Contact-container-right-textarea'
            value={formData['lead-message']}
            onChange={handleChange}
            required
          ></textarea>
          <button type='submit' className='Contact-container-right-button'>
            Send
          </button>
        </form>
      </div>
    </div>
  );
};
